// Add all JS development here
jQuery(function ($) {
  $(document).ready(function () {
    $ = jQuery.noConflict();
    // //Add Fixed Nav bar function ***********
    var previousScroll = 0;
    var navBar = $("#navigation-scroll");

    $(window).scroll(function () {
      var currentScroll = $(this).scrollTop();

      if (currentScroll > 100 && currentScroll > previousScroll) {
        hideNav();
      } else {
        showNav();
      }

      previousScroll = currentScroll;
    });

    function hideNav() {
      navBar.addClass("is-hidden");
    }

    function showNav() {
      navBar.removeClass("is-hidden");
    }

    // //Add Fixed Nav bar function ******

    $('.menu-navigation-toggle').click(function () {

      $('.menu-content').toggleClass('open', 300);

      $(this).toggleClass('active');

    });

    $(".hero-slider").owlCarousel({
      loop: true,
      margin: 0,
      nav: false,
      dots: true,
      lazyLoad: true,
      transitionStyle: "fade",
      animateOut: 'animate__fadeOut',
      animateIn: 'animate__fadeIn',
      // slideTransition: 'linear',
      autoplay: true,
      autoplayTimeout: 10000,
      autoplaySpeed: 1000,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });

    $('.services-slider').owlCarousel({
      loop: true,
      margin: 10,
      nav: false,
      responsive: {
        0: {
          items: 1,
          lazyLoad: true,
          transitionStyle: "fade",
          animateOut: 'animate__fadeOutLeftBig',
          animateIn: 'animate__fadeInRight',
          autoplay: true,
          autoplayTimeout: 8000,
          autoplaySpeed: 1000,
        },
        600: {
          items: 1,
          touchDrag: true,
          mouseDrag: true,
        },
        1000: {
          items: 4,
          mouseDrag: false,
          touchDrag: false
        }
      }
    })

    $('.testinominal-slider').owlCarousel({
      loop: true,
      margin: 10,
      nav: false,
      navText: [
        "<div class='prev-slide'><img src='myprevimage.png'></div>",
        "<div class='next-slide'><img src='mynextimage.png'>></div>",
      ],
      dots: false,
      lazyLoad: true,
      autoplay:true,
      autoplayTimeout:5000,
      autoplaySpeed: 1000,
      animateOut: 'animate__fadeOutLeft',
      animateIn: 'animate__fadeInRight',
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    })

    $('.gallery-slider').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 3
        },
        1000: {
          items: 1
        }
      }
    })

  });
});

